// Note from Alex: This is an internal utility, and i don't feel like forking it.
import { looseToNumber } from "@vue/shared";
import type { InputDatePickerModelModifiers, CustomModelModifiers } from "../types";

export function createDateModelModifiers(v: InputDatePickerModelModifiers): InputDatePickerModelModifiers {
  return {
    "date-obj": v["date-obj"],
    "date-only": v["date-only"],
    string: v.string,
  };
}

export function createNumberModelModifier(): CustomModelModifiers<"number"> {
  return { number: true };
}

export function parseVTextModelModifiers<ModelValue extends string | number | null = string | number | null>(
  modelModifiers: CustomModelModifiers<"number" | "trim">,
  v: unknown,
): ModelValue {
  let n = v;
  if (modelModifiers.trim && typeof n === "string") {
    n = n.trim();
  }
  if (modelModifiers.number) {
    return looseToNumber(n);
  }
  return n as ModelValue;
}

export function parseVSelectModelModifiers(modelModifiers: CustomModelModifiers<"number">, v: unknown) {
  let n = v;
  if (modelModifiers.number) {
    n = looseToNumber(n);
  }
  return n;
}
